import omit from "lodash/omit";
import {FaInfoCircle} from "react-icons/fa";

// @ts-expect-error TS7016
import TransactionUtils from "@/legacy/transaction/TransactionUtils";
import {TxnResult} from "@/lib/types/transaction.ts";

interface RCAStepDetailsProps {
  idx: number;
  result: TxnResult;
}

export const RCAStepDetails = ({idx, result}: RCAStepDetailsProps) => {
  if (!result.details || !result.details.status_code) {
    return null;
  }

  const id = `step-results-${idx}`;
  return (
    <>
      <button
        className="btn btn-sm btn-link text-decoration-none float-end m-0 me-1 p-0"
        data-bs-toggle="collapse"
        data-bs-target={`#${id}`}
        type="button"
        aria-expanded="false"
        aria-controls={id}
      >
        <FaInfoCircle className="" />
      </button>
      <div className="collapse" id={id}>
        <div className="details-panel card card-body-slim bg-light-2 m-2 p-2">
          <dl
            dangerouslySetInnerHTML={{
              __html: TransactionUtils.formatStepDetails(omit(result.details, ["__typename"])),
            }}
          />
        </div>
      </div>
    </>
  );
};
